module.exports = __webpack_public_path__ + "img/garages.6f674e3b.png";